import { render } from "./TeethArea.vue?vue&type=template&id=44207b22&scoped=true"
import script from "./TeethArea.vue?vue&type=script&lang=js"
export * from "./TeethArea.vue?vue&type=script&lang=js"

import "./TeethArea.vue?vue&type=style&index=0&id=44207b22&scoped=true&lang=css"
import "./TeethArea.vue?vue&type=style&index=1&id=44207b22&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44207b22"]])

export default __exports__